import { Component, ReactNode } from 'react'
import { ModalNodeProps } from '../../../../components/modal.component'
import { BOOKING_TYPE, TaskDto, TaskStatus } from '../../../../../definition'
import getTaskStatus from '../../../../components/task-status.component'
import moment from 'moment'
import { renderDesignateAddress } from '../../../../../utils'
import { Tooltip } from 'antd'

const statusOrder: Partial<Record<TaskStatus, TaskDto[]>> = {
  [TaskStatus.CREATED]: [],
  [TaskStatus.RESCHEDULE]: [],
  [TaskStatus.ASSIGNED]: [],
  [TaskStatus.ON_THE_WAY]: [],
  [TaskStatus.STARTED]: [],
  [TaskStatus.COMPLETED]: [],
  [TaskStatus.DONE]: [],
  [TaskStatus.CANCELED]: []
}

export class AllTaskInDayModal extends Component<
  ModalNodeProps,
  {
    tasks: TaskDto[]
    mainCategory?: string
  }
> {
  render(): ReactNode {
    const tasks: TaskDto[] = this.props.input.tasks
    const groupByStatus = Object.groupBy(tasks, (task) => task.status)

    const groupByStatusOrder = {
      ...statusOrder,
      ...Object.fromEntries(Object.entries(groupByStatus).map(([status, tasks]) => [status, tasks]))
    }

    return (
      <div className='all-task-in-day-modal' style={{ minWidth: 800 }}>
        {Object.entries(groupByStatusOrder)
          .filter(([_, tasks]) => tasks.length > 0)
          .map(([status, tasks]) => {
            const { cssStatus, statusLabel } = getTaskStatus(tasks?.[0].status)
            return (
              <div key={status} className='task-by-status'>
                <h3>{statusLabel}</h3>
                {tasks.map((task) => {
                  const bookingType = task.booking?.type
                  const bookingLink = bookingType === BOOKING_TYPE.RECURRING ? 'contract-booking' : 'one-time-booking'
                  return (
                    <Tooltip
                      title={
                        <div key={task.code}>
                          <div style={{ fontWeight: 600 }}>{task.booking?.code}</div>
                          <div>{moment(task.timeSlotBeginAt).format('DD/MM/YYYY')}</div>
                          <div>{moment(task.timeSlotBeginAt).format('HH:mm')}</div>
                          <div>{renderDesignateAddress(task)}</div>
                          <div>{task.postalCode}</div>
                          <div>{this.props.input.mainCategory}</div>
                          <div>{task.service?.name}</div>
                        </div>
                      }
                    >
                      <div
                        key={task.code}
                        className={`${cssStatus} task-by-status-item`}
                        onClick={() => window.open(`/schedule/${bookingLink}?bookingId=${task.bookingId}`, '_blank')}
                      >
                        <div style={{ fontWeight: 600 }}>{task.booking?.code}</div>
                        <div>{moment(task.timeSlotBeginAt).format('DD/MM/YYYY')}</div>
                        <div>{moment(task.timeSlotBeginAt).format('HH:mm')}</div>
                        <div>{renderDesignateAddress(task)}</div>
                        <div>{task.postalCode}</div>
                        <div>{this.props.input.mainCategory}</div>
                        <div>{task.service?.name}</div>
                      </div>
                    </Tooltip>
                  )
                })}
              </div>
            )
          })}
      </div>
    )
  }
}
